export default __webpack_public_path__ + "static/media/summary_planimages_84d.3849e213.png";